import React from 'react';
import { Route } from 'react-router-dom';

import { lazy } from '@components/common/routeLoading';
import { Path } from '@components/routes/constants';
import { SECTION } from '@hooks/useDocumentTitle/constants';
import { RedirectRoute } from '@components/routes/redirect';
import { entitled } from '@components/routes/routeEntitlement';
import { useIsDataMapperEnabled } from '@components/routes/entitlements';

const DataMapperPage = lazy(() =>
  import(/* webpackChunkName: "dataMapper" */ '@components/dataMapper').then((module) => ({
    default: module.DataMapperPage,
  })),
);

/**
 * See the note in @components/botManagement/routes on why these are definitions.
 *
 * The feature flag used to decide whether the index route was registered at all,
 * leaving the sibling `*` route to redirect. It now gates the element instead,
 * which redirects the same way — see @components/routes/routeEntitlement.
 */
export const dataMapperRoutes = (
  <Route key={Path.DATA_MAPPER} path={Path.DATA_MAPPER} handle={{ section: SECTION.dataMapper }}>
    <Route index element={entitled(useIsDataMapperEnabled, <DataMapperPage />)} />
    <Route path="*" element={<RedirectRoute />} />
  </Route>
);
